
export enum Role {
  CLIENT = 'client',
  ADMIN = 'admin',
}

export enum ProductStatus {
  ON_SALE = 'en_vente',
  SOLD_OUT = 'épuisé',
  INCOMING = 'en_arrivage',
}

export enum UserStatus {
  ACTIVE = 'actif',
  SUSPENDED = 'suspendu',
  /** En attente de confirmation email après inscription */
  PENDING_EMAIL = 'en_attente_email',
}

export enum PaymentMethodCode {
  SOLDE_INTERNE = 'solde_interne',
  LIVRAISON = 'livraison',
  CARTE_BANCAIRE = 'carte_bancaire',
  CARTE_POSTALE = 'carte_postale',
  VIREMENT_BANCAIRE = 'virement_bancaire',
  VIREMENT_POSTAL = 'virement_postal',
  MANDAT_MINUTE = 'mandat_minute',
  MANDAT_NORMALE = 'mandat_normale',
  MANDAT_BANCAIRE = 'mandat_bancaire',
  PORTEFEUILLE_FLOUCI = 'portefeuille_flouci',
  PORTEFEUILLE_D17 = 'portefeuille_d17',
  PORTEFEUILLE_IZI_PAY = 'portefeuille_izi_pay',
  PORTEFEUILLE_WAFACASH = 'portefeuille_wafacash',
  P2P = 'p2p',
}

export enum PaymentFamily {
  SOLDE = 'solde',
  LIVRAISON = 'livraison',
  CARTE = 'carte',
  VIREMENT = 'virement',
  MANDAT = 'mandat',
  PORTEFEUILLE = 'portefeuille',
  P2P = 'p2p',
}

export const PAYMENT_METHOD_FAMILY: Record<PaymentMethodCode, PaymentFamily> = {
  [PaymentMethodCode.SOLDE_INTERNE]: PaymentFamily.SOLDE,
  [PaymentMethodCode.LIVRAISON]: PaymentFamily.LIVRAISON,
  [PaymentMethodCode.CARTE_BANCAIRE]: PaymentFamily.CARTE,
  [PaymentMethodCode.CARTE_POSTALE]: PaymentFamily.CARTE,
  [PaymentMethodCode.VIREMENT_BANCAIRE]: PaymentFamily.VIREMENT,
  [PaymentMethodCode.VIREMENT_POSTAL]: PaymentFamily.VIREMENT,
  [PaymentMethodCode.MANDAT_MINUTE]: PaymentFamily.MANDAT,
  [PaymentMethodCode.MANDAT_NORMALE]: PaymentFamily.MANDAT,
  [PaymentMethodCode.MANDAT_BANCAIRE]: PaymentFamily.MANDAT,
  [PaymentMethodCode.PORTEFEUILLE_FLOUCI]: PaymentFamily.PORTEFEUILLE,
  [PaymentMethodCode.PORTEFEUILLE_D17]: PaymentFamily.PORTEFEUILLE,
  [PaymentMethodCode.PORTEFEUILLE_IZI_PAY]: PaymentFamily.PORTEFEUILLE,
  [PaymentMethodCode.PORTEFEUILLE_WAFACASH]: PaymentFamily.PORTEFEUILLE,
  [PaymentMethodCode.P2P]: PaymentFamily.P2P,
};

/** Récupère la PaymentFamily à partir d'un PaymentMethodCode */
export function getFamilyFromMethodCode(code?: PaymentMethodCode): PaymentFamily | undefined {
  if (!code) return undefined;
  return PAYMENT_METHOD_FAMILY[code];
}

export const INSTANT_PAYMENT_METHODS: PaymentMethodCode[] = [
  PaymentMethodCode.SOLDE_INTERNE
];

export enum DepositStatus {
  PENDING = 'en_attente',
  VALIDATED = 'validé',
  REFUSED = 'refusé',
}

export enum OrderStatus {
  PENDING = 'pending',
  IN_DELIVERY = 'in_delivery',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  DISPUTE = 'dispute',
}

export enum DeliveryMethod {
  CODE_INSTANTANE = 'code_instantane',
  MAIL_COMPTE_CODE = 'mail_compte_code',
  MAIL_CODE = 'mail_code',
  MAIL_ACCES = 'mail_acces',
  MAIL_LICENCE = 'mail_licence',
  TRAITEMENT_LIEN = 'traitement_lien',
  LIVRAISON_DOMICILE = 'livraison_domicile',
}

export enum DeliveryStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  AWAITING_DELIVERY = 'awaiting_delivery',
  IN_DELIVERY = 'in_delivery',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  REFUNDED = 'refunded',
}

export enum ProductSaleType {
  DETAIL = 'detail',
  GROS = 'gros',
}

export enum TicketStatus {
  OPEN = 'ouvert',
  IN_PROGRESS = 'en_cours',
  CLOSED = 'fermé',
}

export enum TicketType {
  SUPPORT = 'SUPPORT',
  COMMANDE = 'COMMANDE',
  CONTACT = 'CONTACT',
}

export enum TicketSource {
  DASHBOARD = 'DASHBOARD',
  CONTACT_FORM = 'CONTACT_FORM',
}

export enum TicketPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

export enum NotificationType {
  // Tickets
  TICKET_REPONSE = 'ticket_reponse',
  TICKET_STATUT = 'ticket_statut',
  TICKET_CREE = 'ticket_cree',
  TICKET_URGENCE = 'ticket_urgence',
  
  // Dépôts
  DEPOT_VALIDE = 'depot_valide',
  DEPOT_REFUSE = 'depot_refuse',
  DEPOT_CREE = 'depot_cree',
  
  // Commandes
  COMMANDE_STATUT = 'commande_statut',
  COMMANDE_CREEE = 'commande_creee',
  COMMANDE_PAYEE = 'commande_payee',
  COMMANDE_LIVREE = 'commande_livree',
  COMMANDE_ANNULEE = 'commande_annulee',
  COMMANDE_LITIGE = 'commande_litige',
  
  // Système
  NOUVEAU_CLIENT = 'nouveau_client',
  NOUVEAU_TICKET = 'nouveau_ticket',
  STOCK_FAIBLE = 'stock_faible',
  STOCK_EPUISE = 'stock_epuise',
  SYSTEM_ALERT = 'system_alert',
}

export enum NotificationPriority {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
  URGENT = 'urgent',
}

export enum PreferenceType {
  SELECT = 'select',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  COLOR = 'color',
   TEXT = 'text',
   PHONE = 'phone',
   TEXTAREA = 'textarea',
  URL = 'url',
  FILE = 'file',
  USER_INPUT_AMOUNT = 'user_input_amount',
  BUTTON = 'button'
}

export interface PreferenceCondition {
  groupLabel: string;
  optionLabel: string;
  price?: number;
  isPriceOverride?: boolean;
  features?: string[];
}

export interface PreferenceOption {
  name: string;
  priceModifier: number;
  isPriceOverride?: boolean;
  features?: string[];
  colorCode?: string;
  conditions?: PreferenceCondition[];
}

export interface Preference {
  key: string;
  label: string;
  type: PreferenceType;
  required?: boolean;
  options: PreferenceOption[];
  priceOverlay?: number;
}

export interface Product {
  id: number;
  nom: string;
  description?: string;
  prix: number;
  statut: ProductStatus;
  est_validé: boolean;
  est_meilleure_vente?: boolean;
  preferences?: Preference[];
  image_url?: string;
  logo_url?: string;
   delivery_method: DeliveryMethod;
  type_vente: ProductSaleType;
  quantite_min: number;
  stock_quantity?: number;
  valeur?: string;
  sub_category_nom?: string;
  categorie_id?: string;
  categorie_nom?: string;
  rating_avg?: number;
  rating_count?: number;
  other_images?: string[];
  low_stock_threshold?: number;
  reviews?: any[];
}

export interface Category {
  id: string;
  nom: string;
  description: string;
  image_url?: string;
}

export interface SubCategory {
  id: string;
  nom: string;
  categorie_id: string;
  description?: string;
  image_url?: string;
}

export interface User {
  id: string;
  nom: string;
  prénom: string;
  email: string;
  role: Role;
  solde: number;
  statut: UserStatus;
  téléphone: string;
  adresse: string;
  avatarUrl?: string;
  avatar_url?: string;
  date_creation: string;
  totalOrders?: number;
  totalDeposits?: number;
  email_verified?: boolean;
  email_confirmed_at?: string | null;
  phone_verified?: boolean;
  phone_verified_at?: string | null;
  is_active?: boolean;
  deactivated_at?: string | null;
  /** Compte de test pour l'examen Google Play Store : bypass OTP et vérification email */
  is_play_store_test_account?: boolean;
}

export interface Deposit {
  id: number;
  user_id: string;
  montant: number;
  payment_method_detail?: PaymentMethodCode;
  méthode?: PaymentFamily;
  preuve?: string;
  statut: DepositStatus;
  date: string;
  user?: {
    nom: string;
    prénom: string;
    email: string;
  };
}

export interface OrderItem {
  produit_id: number;
  nom_produit: string;
  prix_unitaire: number;
  quantite: number;
  configuration?: any;
  delivery_method?: DeliveryMethod;
  delivery_status?: DeliveryStatus;
  delivery_metadata?: any;
}

export interface Order {
  id: number;
  user_id: string;
  items: OrderItem[];
  montant_total: number;
  mode_paiement?: PaymentFamily;
  payment_method_detail?: PaymentMethodCode;
  payment_setting_id?: number | null;
  preuve?: string;
  transaction_id?: string;
  statut: OrderStatus;
  date: string;
  invoice_url?: string;
  invoice_number?: string;
  invoice_date?: string;
  delivery_note_url?: string;
  delivery_note_number?: string;
  user?: User;
  /** Type de commande (migration orders) */
  type?: 'NORMAL' | 'REPLACEMENT' | 'COMPENSATION';
  /** Statut workflow (problème résolu, etc.) */
  workflow_status?: string;
  /** Commande d'origine si remplacement/compensation */
  parent_order_id?: number | null;
  /** Frais de livraison à domicile */
  delivery_fee?: number;
  /** Timbre fiscal */
  stamp_fee?: number;
}

export interface AdminStats {
  totalRevenue: number;
  totalUsers: number;
  totalOrders: number;
  pendingDeposits: number;
  revenueByOperator: { name: string; value: number }[];
  ordersByStatus: { name: string; value: number }[];
}

export interface SecurityStats {
  // IP & OTP
  blockedIpsActive: number;
  blockedIpsLast24h: number;
  ipWithActivity24h: number;
  otpSentLast24h: number;
  otpValidatedLast24h: number;
  otpSuccessRate24h: number;

  // Tickets & reviews
  openTickets: number;
  avgFirstResponseHours: number | null;
  avgRating: number | null;
  reviewsCount30d: number;

  // Comptes & 2FA
  expiredAccounts24h: number;
  expiredAccountsTotal: number;
  twoFaEnabledUsers: number;
}

export interface TicketMessage {
  id: number;
  ticket_id: number;
  user_id: string | null;
  message: string;
  fichier_joint?: string;
  date: string;
  user?: {
    nom: string;
    prénom: string;
    role: Role;
  };
}

export interface Ticket {
  id: number;
  user_id: string | null;
  sujet: string;
  statut: TicketStatus;
  type: TicketType;
  source: TicketSource;
  priority: TicketPriority;
  date_creation: string;
  date_maj: string;
  email_contact?: string;
  nom_contact?: string;
  user?: User;
  messages: TicketMessage[];
}

export interface Notification {
  id: string;
  user_id: string;
  type: NotificationType;
  message: string;
  lien: string;
  priority: NotificationPriority;
  metadata: {
    order_id?: number;
    deposit_id?: number;
    ticket_id?: number;
    amount?: number;
    old_status?: string;
    new_status?: string;
    [key: string]: any; // Pour extensibilité
  };
  read_at: string | null;
  created_at: string;
  expires_at: string | null;
  channels: string[]; // ['in_app', 'email', 'push']
  read_channels: string[]; // Canaux où la notification a été lue
  
  // Champs de compatibilité (deprecated)
  date?: string;
  lu_a?: string | null;
}

export interface CreateNotificationInput {
  user_id: string;
  type: NotificationType;
  message: string;
  lien: string;
  priority?: NotificationPriority;
  metadata?: Record<string, any>;
  expires_at?: string;
  channels?: string[];
}

export interface NotificationFilters {
  limit?: number;
  offset?: number;
  unread_only?: boolean;
  type_filter?: NotificationType;
}

export interface NotificationStats {
  total: number;
  unread: number;
  by_type: Record<NotificationType, number>;
  by_priority: Record<NotificationPriority, number>;
}

export const ADMIN_PAYMENT_METHOD_CODES = Object.values(PaymentMethodCode);

export type AdminPaymentMethodCode = PaymentMethodCode;

export function isAdminPaymentMethodCode(v: string): v is AdminPaymentMethodCode {
  return (ADMIN_PAYMENT_METHOD_CODES as readonly string[]).includes(v as PaymentMethodCode);
}

/** Anciennes valeurs en base avant renommage — lues puis normalisées côté API. */
export const LEGACY_ADMIN_METHOD_CODE_ALIASES: Record<string, AdminPaymentMethodCode> = {
  virement: PaymentMethodCode.VIREMENT_BANCAIRE,
  postal: PaymentMethodCode.MANDAT_NORMALE,
};

export function coerceAdminMethodCode(raw: unknown): AdminPaymentMethodCode | null {
  if (raw == null) return null;
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (!s) return null;
  const mapped = LEGACY_ADMIN_METHOD_CODE_ALIASES[s];
  if (mapped) return mapped;
  if (isAdminPaymentMethodCode(s)) return s as AdminPaymentMethodCode;
  return null;
}

/** Portées suggérées à la création d’une ligne (l’admin peut les ajuster). */
export function defaultScopesForMethodCode(code: PaymentMethodCode): {
  for_order: boolean;
  for_deposit: boolean;
  for_product: boolean;
} {
  const family = PAYMENT_METHOD_FAMILY[code];
  switch (family) {
    case PaymentFamily.SOLDE:
      return { for_order: true, for_deposit: false, for_product: true };
    case PaymentFamily.LIVRAISON:
      return { for_order: true, for_deposit: false, for_product: true };
    case PaymentFamily.P2P:
      return { for_order: true, for_deposit: true, for_product: true };
    case PaymentFamily.MANDAT:
      return { for_order: true, for_deposit: true, for_product: true };
    case PaymentFamily.PORTEFEUILLE:
    case PaymentFamily.VIREMENT:
    case PaymentFamily.CARTE:
      return { for_order: true, for_deposit: true, for_product: true };
    default:
      return { for_order: true, for_deposit: true, for_product: true };
  }
}

/** Enum PostgreSQL `payment_setting_category` (+ valeurs texte historiques éventuelles). */
export const PAYMENT_SETTING_CATEGORIES = [
  'carte_bancaire',
  'carte_prepayee',
  'carte_credit',
  'carte_debit',
  'virement_bancaire',
  'virement_postal',
  'p2p',
  'portefeuille_electronique',
  'portefeuille_mobile',
  'solde_interne',
  'mandat_cash',
  'mandat_compte',
  'mandat_postal',
  /** Transfert ou mandat côté réseau bancaire (ex. MoneyGram) : référence / ordre, pas équivalent mandat postal. */
  'mandat_bancaire',
  'cheque_bancaire',
  'cheque_postal',
  'cheque_vacances',
  'especes',
  'prelevement_automatique',
  'cryptomonnaie',
  'autre',
] as const;

export type PaymentSettingCategory = (typeof PAYMENT_SETTING_CATEGORIES)[number];

export type PaymentSettingCategoryOrLegacy = PaymentSettingCategory | 'BANQUE' | 'CCP' | 'WALLET';

export function isPaymentSettingCategory(v: string): v is PaymentSettingCategory {
  return (PAYMENT_SETTING_CATEGORIES as readonly string[]).includes(v);
}

export interface PaymentSetting {
  id: number;
  created_at?: string;
  /** Libellé de la ligne (ex. compte, banque). */
  provider_name: string;
  /**
   * Identifiant affiché au client : RIB (virement bancaire), CCP (virement postal),
   * mobile TN (portefeuille), ou optionnel type CIN / référence (mandats).
   */
  identifier: string | null;
  iban?: string | null;
  account_holder?: string | null;
  /**
   * Clé canonique = valeur d'enum côté base.
   */
  method_code: PaymentMethodCode;
  /**
   * Famille de la méthode (solde, portefeuille, etc)
   */
  family: PaymentFamily;
  for_order: boolean;
  for_deposit: boolean;
  /** Catalogue produits (`payment_method[]`). */
  for_product: boolean;
  is_enabled: boolean;
  sort_order: number;
  /** Instructions optionnelles affichées au client pour cette ligne. */
  instructions?: string | null;
}

export interface MediaItem {
  id: number;
  file_name: string;
  file_path: string;
  bucket_name: string;
  public_url: string;
  size: number;
  mime_type: string;
  created_at: string;
}

export interface DigitalCode {
  id: number;
  product_id: number;
  order_id?: number;
  reference: string;
  code_encrypted?: string;
  decrypted_code?: string;
  serial_number?: string;
  status: 'available' | 'sold' | 'expired';
  expiration_date?: string;
  created_at: string;
  sold_at?: string;
  buyer_id?: string;
  product?: Product;
  /** Nom du produit de la ligne de commande (prioritaire pour l’affichage, évite les mélanges code/ligne) */
  order_item_nom_produit?: string;
}

export interface StockStat {
  product_id: number;
  product_name: string;
  available_count: number;
  used_count: number;
}

export interface InventoryMovement {
  id: number;
  product_id: number;
  movement_type: 'IN' | 'OUT' | 'SALE';
  quantity: number;
  reason: string;
  created_at: string;
  user?: {
    nom: string;
    prénom: string;
  };
}

export const PAYMENT_RULES: Record<string, PaymentFamily[]> = {
  [DeliveryMethod.CODE_INSTANTANE]: [PaymentFamily.SOLDE, PaymentFamily.CARTE],
  [DeliveryMethod.MAIL_COMPTE_CODE]: Object.values(PaymentFamily).filter(f => f !== PaymentFamily.LIVRAISON),
  [DeliveryMethod.MAIL_CODE]: Object.values(PaymentFamily).filter(f => f !== PaymentFamily.LIVRAISON),
  [DeliveryMethod.MAIL_ACCES]: Object.values(PaymentFamily).filter(f => f !== PaymentFamily.LIVRAISON),
  [DeliveryMethod.MAIL_LICENCE]: Object.values(PaymentFamily).filter(f => f !== PaymentFamily.LIVRAISON),
  [DeliveryMethod.TRAITEMENT_LIEN]: Object.values(PaymentFamily).filter(f => f !== PaymentFamily.LIVRAISON),
  [DeliveryMethod.LIVRAISON_DOMICILE]: Object.values(PaymentFamily),
};

/**
 * Mappe PaymentFamily vers PaymentMethodCode (code précis) pour traçabilité.
 * Utilisé lors de la création d'ordre pour enregistrer le rail exact utilisé.
 */
export function paymentFamilyToCode(method: PaymentFamily): PaymentMethodCode {
  switch (method) {
    case PaymentFamily.SOLDE:
      return PaymentMethodCode.SOLDE_INTERNE;
    case PaymentFamily.LIVRAISON:
      return PaymentMethodCode.LIVRAISON;
    case PaymentFamily.CARTE:
      return PaymentMethodCode.CARTE_BANCAIRE;
    case PaymentFamily.VIREMENT:
      return PaymentMethodCode.VIREMENT_BANCAIRE;
    case PaymentFamily.MANDAT:
      return PaymentMethodCode.MANDAT_NORMALE;
    case PaymentFamily.PORTEFEUILLE:
      return PaymentMethodCode.PORTEFEUILLE_FLOUCI;
    case PaymentFamily.P2P:
      return PaymentMethodCode.P2P;
    default:
      return PaymentMethodCode.PORTEFEUILLE_FLOUCI;
  }
}


